import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "src/store/auth/actions";
import { ReactComponent as CheckIcon } from 'src/assets/static/images/ehckec.svg';
import { ReactComponent as NonRed } from 'src/assets/static/images/non-red.svg';
import useFormatById from "src/hooks/utils/useFormatById";
import ConfirmPin from "./ConfirmPin";
import { useTimer } from "./useTimer";
import CurrentDeviceSize from "src/hooks/utils/currentDeviceSize";
import { useNavigate } from "react-router";

function IdentomatResult({ sessionToken }) {
    const dispatch = useDispatch();
    const f = useFormatById();
    const navigate = useNavigate();
    const validateIdentomat = useSelector(state => state.auth.validateIdentomat);
    const sendOTPMobileSuccess = useSelector(state => state.auth.sendOTPMobileSuccess);
    const changeMobileSuccess = useSelector(state => state.auth.changeMobileSuccess);

    useEffect(() => {
        dispatch(actions.getValidateidentomat(sessionToken));
    }, [dispatch])

    const changePage = () => {
        setCurrentWizard((item) => item + 1)
    }

    useEffect(() => {
        if (sendOTPMobileSuccess === true) {
            changePage();
        }
    }, [sendOTPMobileSuccess])

    useEffect(() => {
        if (changeMobileSuccess) {
            navigate('/login');
            dispatch(actions.setIsIdentomat(false))
        }
    }, [changeMobileSuccess])

    const handleWizardChange = () => {
        if (currentWizard === 1) {
            dispatch(actions.getSendotptomobile(mobileNumber));
        }

        if (currentWizard === 2) {
            dispatch(actions.getChangemobile({
                otp: pinCode,
                mobileNumber: mobileNumber,
                identomatSessionId: sessionToken
            }))
        }
    }

    const [currentWizard, setCurrentWizard] = useState(1);
    const showErrors = false;
    const timerTime_Global = useSelector(
        (state) => state.profileMain?.timerTime_Global
    );

    const { pinTimer, setPinTimer } = useTimer();
    const [mobileNumber, setMobileNumber] = useState("");
    useEffect(() => {
        if (!timerTime_Global) {
            const minutes = timerTime_Global === false ? 3 : 0;
            setPinTimer(minutes * 60);
            // dispatch(actions.setSendOTPToUser(false));
        }
    }, [timerTime_Global, dispatch, setPinTimer]);

    const timerExpired = !(pinTimer > 0);
    const [pinCode, setPinCode] = useState("");
    const [showPinInput, setShowPinInput] = useState(true);
    const pinCodeDisabled = useMemo(() => timerExpired, [timerExpired]);

    const currentDeviceSize = CurrentDeviceSize();

    return (
        <div className="validate-identomat mb-5">
            {validateIdentomat?.isValid === true &&
                <div className="text-center mt-5 pb-5">
                    <CheckIcon />
                    <div className="title mt-4">
                        {f('login.validat-title')}
                    </div>
                    <div className="parag mt-3">
                        {f('login.validat-paag')}
                    </div>

                    <div className={"mx-auto mt-5 pb-5" + (currentDeviceSize === "Mobile" ? '' : ' login-container')}>
                        <div className="mb-3 d-flex justify-content-center mt-5">
                            <div className="form-floating pb-1">
                                <input
                                    type="text"
                                    className={
                                        "form-control identomat-pin" + (showErrors ? " error-input-style" : "")
                                    }
                                    id="floatingInput"
                                    value={mobileNumber}
                                    placeholder="Input"
                                    onChange={(e) => setMobileNumber(e.target.value)}
                                    autoComplete="off"
                                    autoFocus
                                />
                                <label htmlFor="floatingInput">{f('mobileNum')}</label>
                            </div>
                        </div>
                        {currentWizard === 2 && (
                            <div className="timer-class text-center">
                                {showPinInput && (
                                    <ConfirmPin
                                        autoFocus={true}
                                        pinTimer={pinTimer}
                                        onChangePinCode={(newPinCode) => setPinCode(newPinCode)}
                                        pinCodeDisabled={pinCodeDisabled}
                                    />
                                )}
                                <div
                                    style={{
                                        cursor: !pinCodeDisabled ? "unset" : "pointer",
                                        opacity: !pinCodeDisabled ? "0.5" : "1",
                                    }}
                                    className="timer-sms-send mt-3"
                                    onClick={() => {
                                        if (pinCodeDisabled)
                                            dispatch(actions.getSendotptomobile(mobileNumber));
                                    }}
                                >
                                    {f("get-sms-code-again")}
                                </div>
                            </div>
                        )}

                        <div className="text-center pt-4 ms-4 me-4">
                            <button
                                className="btn btn-primary login-button"
                                disabled={(currentWizard === 1 && mobileNumber === '') || (currentWizard === 2 && pinCode?.length < 4)}
                                onClick={() => handleWizardChange()}
                            >
                                {f("next")}
                            </button>
                        </div>
                    </div>
                </div>
            }
            {
                validateIdentomat?.isValid === false &&
                <div className="text-center mt-5 pb-5">
                    <NonRed />
                    <div className="title mt-4">
                        {f('vali-title')}
                    </div>
                    <div className="parag pt-3" style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => { navigate('/login'); dispatch(actions.setIsIdentomat(true)) }}>
                        {f('validat-again')}
                    </div>
                </div>
            }
        </div >
    )
}
export default IdentomatResult;